import Clipboard from "@react-native-clipboard/clipboard"
import { isIos } from "../AppEvent"

export const ClipboardUtil = {
    async hasImage(): Promise<boolean> {
        // ClipboardModule 已移除
        if (isIos && Clipboard.hasImage) {
            return Clipboard.hasImage()
        }
        return false
    },

    async setImage(content: string) {
        // ClipboardModule 已移除
        if (isIos && Clipboard.setImage) {
            Clipboard.setImage(content)
            return true
        }
        return false
    },

    async setString(content: string) {
        return Clipboard.setString(content)
    },

    async getImageJPG(): Promise<string> {
        // ClipboardModule 已移除
        if (isIos && Clipboard.getImageJPG) {
            return Clipboard.getImageJPG()
        }
        return ""
    }
}